/**
 * AI Daily Brief API client — обёртка над GET /api/v1/ai/daily-brief.
 * Только для HR/руководящих ролей (backend gating через require_role).
 */

import { apiFetch } from './core'

export const apiGetDailyBrief = ({ force = false } = {}) =>
    apiFetch(`/ai/daily-brief${force ? '?force=true' : ''}`)
